import request from '@/utils/request'

// 获取视频播放令牌
export function getPlayAuth(videoId) {
  return request({
    url: '/api/vod/playAuth/' + videoId,
    method: 'get'
  })
}
